import { Box, Button, Tab, Typography } from '@mui/material'
import _ from 'lodash'
import { useEffect, useRef, useState } from 'react'
import CanvasDraw from 'react-canvas-draw'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'

/** TRANSLATION*/
import { useTranslation } from 'react-i18next'

/** API */
import TreatmentsAPI, { SignatureAttachmentsProps } from 'api/dentists/treatment.api'

/** UTILS || SLICE */
import { ToastContainer } from 'react-toastify'
import { PACKAGE_ADDONS } from 'constants/package'
import { checkAddons, checkPackage, getClinicInfo } from 'utils/app.utils'

/** COMPONENT */
import Loading from 'component/Loading'
import { notiPopup, notiSuccess } from 'component/notifications/notifications'

/** STYLE */
import { appendInvoice, selectCurrentInvoice, setCurrentInvoice } from 'app/slice/invoice.slice'
import { selectMe } from 'app/slice/user.slice'
import axios from 'axios'
import PdfInvoice from 'component/Print/pdfInvoice'
import * as UseStyled from 'component/Treatments/style/popupTreatmentConsentUseStyled'
import { Config } from 'config'
import { colors } from 'constants/theme'
import MainButton from 'new-components/buttons/main-button'
import { useWacomPenInput } from 'services/wacom/useWacomPenInput'
import WacomStatusChip from 'services/wacom/WacomStatusChip'

const transformScale = 0.7

export default function InvoiceView() {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const location = useLocation()
    const branchInfo = getClinicInfo()
    const currentInvoice = useSelector(selectCurrentInvoice);
    const user = useSelector(selectMe)
    const [doctorTab, setDoctorTab] = useState(0);
    const [treatments, setTreatments]: any = useState([]);
    const [noteNextVisit, setNoteNextVisit]: any = useState([]);
    const [treatment, setTreatment]: any = useState([]);
    const [loading, setLoading] = useState(true);
    const [clear, setClear] = useState(false);
    const [submit, setSubmit] = useState(false);
    const [defaultDoctorSignature, setDefaultDoctorSignature] = useState<any>();
    const [defaultPatientSignature, setDefaultPatientSignature] = useState<any>();
    const [modalType, setModalType] = useState<'doctor' | 'patient'>('doctor');
    const [disabledBtn, setDisabledBtn] = useState(false);
    const [canvasKey, setCanvasKey] = useState(Date.now());
    const [saving, setSaving] = useState(false);
    const [hasSaved, setHasSaved] = useState(false);
    const canvasDoctorRef: any = useRef()
    const canvasPatientRef: any = useRef()
    const defaultSignature: SignatureAttachmentsProps = {
        doctorId: 0,
        servicePointId: 0,
        doctorSignature: '',
        patientSignature: ''
    }
    const [signatureCurrent, setSignatureCurrent] = useState<SignatureAttachmentsProps>(defaultSignature);

    // Get parameters from URL
    const queryParams = new URLSearchParams(location.search);
    const patientCaseId = Number(queryParams.get('patientCaseId')) || 0;
    const servicePointId = Number(queryParams.get('servicePointId')) || 0;
    const type = (queryParams.get('type') as 'treatment' | 'historyTreatment' | 'payment') || 'treatment';
    const userId = Number(queryParams.get('userId')) || undefined;
    const token = queryParams.get('token') || ''

    const loadData = async (token: any) => {
        const resp = await TreatmentsAPI.findInvoiceTreatmentToken(token).finally(() => setLoading(false));
        console.log('resp', resp)
        if (resp.status === 200) {
            const invoices = type === 'historyTreatment' ?
                _.filter(resp.data, (data) => data.invoice) :
                _.filter(resp.data, (data) => !_.isEmpty(data.summeryTreatments) || !_.isEmpty(data?.summeryProducts));
            await joinNextVisit(invoices)
            setTreatments(invoices);
            setTreatment(invoices[doctorTab]);
            setDisabledBtn(userId !== invoices[doctorTab]?.doctorId)
            invoices.forEach((invoice, index) => {
                if (invoice?.invoice) {
                    dispatch(appendInvoice({
                        index, value: {
                            servicePointId: servicePointId,
                            doctorId: invoice?.invoice?.doctorId,
                            doctorSignature: invoice?.invoice?.doctorSignature,
                            patientSignature: invoice?.invoice?.patientSignature
                        }
                    }));
                } else if (invoice.doctorSignature) {
                    let invoiceData: any = {};
                    convertImageToBase64(`${Config.REACT_APP_IMAGE_URL}/${invoice.doctorSignature}`)
                        .then((base64) => {
                            let base64string: any = `${base64}`.split(',')
                            base64string = base64string[base64string.length - 1]
                            invoiceData = {
                                ...currentInvoice,
                                doctorId: invoice?.doctorId,
                                doctorSignature: base64string,
                                patientSignature: invoice?.invoice?.patientSignature
                            }
                        })
                        .catch((error) => console.error("Error:", error));
                    dispatch(appendInvoice({ index, value: invoiceData }));
                } else {
                    dispatch(appendInvoice({
                        index, value: {
                            ...currentInvoice,
                            doctorId: invoice?.doctorId,
                            doctorSignature: '',
                            patientSignature: ''
                        }
                    }));
                }
            });
            if (invoices) {
                if (invoices[doctorTab]?.invoice) {
                    dispatch(setCurrentInvoice({
                        ...currentInvoice,
                        doctorId: invoices[doctorTab]?.doctorId,
                        doctorSignature: invoices[doctorTab]?.invoice.doctorSignature,
                        patientSignature: invoices[doctorTab]?.invoice?.patientSignature
                    }));
                } else if (invoices[doctorTab]?.doctorSignature) {
                    convertImageToBase64(`${Config.REACT_APP_IMAGE_URL}/${invoices[doctorTab]?.doctorSignature}`)
                        .then((base64) => {
                            let base64string: any = `${base64}`.split(',')
                            base64string = base64string[base64string.length - 1]
                            setDefaultDoctorSignature(base64)
                            dispatch(setCurrentInvoice({
                                ...currentInvoice,
                                doctorId: invoices[doctorTab]?.doctorId,
                                doctorSignature: base64string,
                                patientSignature: invoices[doctorTab]?.invoice?.patientSignature
                            }));
                        })
                        .catch((error) => console.error("Error:", error));
                } else {
                    dispatch(setCurrentInvoice({
                        ...currentInvoice,
                        doctorId: invoices[doctorTab]?.doctorId,
                        doctorSignature: invoices[doctorTab]?.invoice?.doctorSignature,
                        patientSignature: invoices[doctorTab]?.invoice?.patientSignature
                    }));
                }
            }
            const currentInv = invoices[doctorTab]?.invoice
            const alreadySaved = !!(currentInv?.doctorSignature && currentInv?.patientSignature)
            setHasSaved(alreadySaved)
        }
    };

    const joinNextVisit = (data: any) => {
        const dataInvoices: any = []
        data?.forEach((item: any) => {
            item.summeryTreatments.forEach((e: any) => {
                dataInvoices.push({ doctorId: e.doctorId, noteNextVisit: e.noteNextVisit })
            })
        })

        const grouped = dataInvoices.reduce((acc: any, cur: any) => {
            if (cur.noteNextVisit.trim() === "") {
                return acc;
            }
            if (!acc[cur.doctorId]) {
                acc[cur.doctorId] = [];
            }
            acc[cur.doctorId].push(cur.noteNextVisit);
            return acc;
        }, {});

        const result = Object.entries(grouped).map(([doctorId, notes]: any) => ({
            doctorId: Number(doctorId),
            noteNextVisit: notes.join(';')
        }));
        setNoteNextVisit(result)
    }

    const handleChangeTab = (event: React.SyntheticEvent, newValue: number) => {
        setDisabledBtn(userId !== treatments[newValue]?.doctorId)
        if (treatments[newValue]?.invoice) {
            dispatch(setCurrentInvoice({
                ...currentInvoice,
                doctorId: treatments[newValue]?.doctorId,
                doctorSignature: treatments[newValue]?.invoice.doctorSignature,
                patientSignature: treatments[newValue]?.invoice?.patientSignature
            }));
        } else {
            if (treatments[newValue].doctorSignature !== null) {
                convertImageToBase64(`${Config.REACT_APP_IMAGE_URL}/${treatments[newValue]?.doctorSignature}`)
                    .then((base64) => {
                        let base64string: any = `${base64}`.split(',')
                        base64string = base64string[base64string.length - 1]
                        setDefaultDoctorSignature(base64)
                        setDefaultPatientSignature(undefined)
                        dispatch(setCurrentInvoice({
                            ...currentInvoice,
                            doctorId: treatments[newValue]?.doctorId,
                            doctorSignature: base64string,
                            patientSignature: treatments[newValue]?.invoice?.patientSignature
                        }));
                    })
                    .catch((error) => console.error("Error:", error));
            } else {
                setDefaultDoctorSignature(undefined)
                setDefaultPatientSignature(undefined)
            }
        }

        clearCanvas('both');
        setDoctorTab(newValue);
        setTreatment(treatments[newValue]);
        const tabInv = treatments[newValue]?.invoice
        setHasSaved(!!(tabInv?.doctorSignature && tabInv?.patientSignature))
        dispatch(setCurrentInvoice({
            ...currentInvoice,
            doctorId: treatments[newValue]?.doctorId,
            doctorSignature: treatments[newValue]?.invoice?.doctorSignature,
            patientSignature: treatments[newValue]?.invoice?.patientSignature
        }))
    };

    const renderCanvas = (type: 'doctor' | 'patient') => {
        if (type === 'doctor') {
            if (canvasDoctorRef.current) {
                const base64 = canvasDoctorRef.current.canvasContainer.childNodes[1].toDataURL('image/jpg')
                let base64string: any = `${base64}`.split(',')
                base64string = base64string[base64string.length - 1]
                setSignatureCurrent({ doctorId: treatment?.doctorId, servicePointId: servicePointId, doctorSignature: base64string, patientSignature: currentInvoice?.patientSignature })
            }
        } else {
            if (canvasPatientRef.current) {
                const base64 = canvasPatientRef.current.canvasContainer.childNodes[1].toDataURL('image/jpg')
                let base64Doctor = currentInvoice?.doctorSignature;
                let base64string: any = `${base64}`.split(',')
                base64string = base64string[base64string.length - 1]
                if (treatment?.doctorSignature && currentInvoice?.doctorSignature === '') {
                    convertImageToBase64(`${Config.REACT_APP_IMAGE_URL}/${treatment?.doctorSignature}`).then((base64) => {
                        base64Doctor = `${base64}`.split(',')
                        base64Doctor = base64Doctor[base64Doctor.length - 1]
                    }).catch((error) => console.error("Error:", error));
                }
                setSignatureCurrent({ doctorId: treatment?.doctorId, servicePointId: servicePointId, doctorSignature: base64Doctor, patientSignature: base64string })
            }
        }
    }

    const clearCanvas = (type: 'doctor' | 'patient' | 'both') => {
        const clearSignature = (
            ref: React.RefObject<any>,
            defaultSignature: any,
            setDefaultSignature: (value: any) => void
        ) => {
            if (defaultSignature) {
                setDefaultSignature(undefined);
            } else if (ref.current) {
                ref.current.clear();
                ref.current.imgSrc = '';
            }
        };

        if (type === 'doctor' || type === 'both') {
            clearSignature(canvasDoctorRef, defaultDoctorSignature, setDefaultDoctorSignature);
            if (type === 'doctor') {
                setSignatureCurrent(prev => ({
                    ...prev,
                    doctorSignature: '',
                }));
            }
        }

        if (type === 'patient' || type === 'both') {
            clearSignature(canvasPatientRef, defaultPatientSignature, setDefaultPatientSignature);
            if (type === 'patient') {
                setSignatureCurrent(prev => ({
                    ...prev,
                    patientSignature: '',
                }));
            }
        }

        if (type === 'both') {
            setSignatureCurrent(prev => ({
                ...prev,
                doctorSignature: '',
                patientSignature: '',
            }));
        }

        // Wipe the firmware-inked stroke off the Wacom pad's LCD as well —
        // otherwise the signer keeps seeing the old ink on the physical pad.
        wacom.clearPad()

        setCanvasKey(Date.now());
    };

    const handleChange = async () => {
        if (currentInvoice?.doctorSignature) {
            setDefaultDoctorSignature(`data:image/png;base64,${currentInvoice?.doctorSignature}`)
        } else {
            convertImageToBase64(`${Config.REACT_APP_IMAGE_URL}/${treatment?.doctorSignature}`)
                .then((base64) => {
                    let base64string: any = `${base64}`.split(',')
                    base64string = base64string[base64string.length - 1]
                    dispatch(setCurrentInvoice({
                        ...currentInvoice,
                        doctorId: treatment[doctorTab]?.userId,
                        doctorSignature: base64string
                    }))
                    setDefaultDoctorSignature(base64)
                }).catch((error) => console.error("Error:", error));
        }
        if (currentInvoice?.patientSignature) {
            setDefaultPatientSignature(`data:image/png;base64,${currentInvoice?.patientSignature}`)
        }
    }

    const convertImageToBase64 = async (url: string): Promise<string> => {
        const response = await axios.get(url, { responseType: "blob" });
        const blob = response.data;
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result as string);
            reader.onerror = (error) => reject(error);
            reader.readAsDataURL(blob);
        });
    };

    const pdfInvoiceRef = useRef<any>(null)

    const onSaveToken = async () => {
        if (saving || hasSaved) return
        if (!currentInvoice?.doctorSignature || !currentInvoice?.patientSignature) {
            notiPopup('warning', t('MODAL_TREATMENT_CONSENT.MESSAGE.ERROR.DEFAULT'))
            return
        }
        setSaving(true)
        try {
            await TreatmentsAPI.saveInvoiceTreatmentToken({
                doctorId: treatment?.doctorId,
                servicePointId,
                doctorSignature: currentInvoice.doctorSignature,
                patientSignature: currentInvoice.patientSignature,
                token,
            })
            setHasSaved(true)
            notiSuccess('บันทึกสำเร็จ')

            // Clear the Wacom pad LCD so the next patient doesn't see the
            // previous signer's ink still on the device.
            wacom.clearPad()

            // โหลดข้อมูลใหม่หลังจากบันทึกสำเร็จ
            await loadData(token)

            // ส่ง message ไปยัง parent window เพื่อให้ reload ข้อมูล
            if (window.opener) {
                window.opener.postMessage({ type: 'INVOICE_SIGNATURE_SAVED', token }, window.location.origin)
            }
        } catch (e) {
            notiPopup('warning', t('MODAL_TREATMENT_CONSENT.MESSAGE.ERROR.DEFAULT'))
        } finally {
            setSaving(false)
        }
    }

    useEffect(() => {
        if (token) loadData(token)
    }, [token]);

    const wacom = useWacomPenInput<'doctor' | 'patient'>({
        canvases: { doctor: canvasDoctorRef, patient: canvasPatientRef },
        active: modalType,
        onStrokeCommit: (slot) => renderCanvas(slot),
    });

    return (
        <Box
            sx={{
                width: '100%',
                minHeight: '100vh',
                backgroundColor: '#f5f5f5',
                display: 'flex',
                flexDirection: 'column',
                overflow: 'auto',
            }}
        >
            {!loading && (
                !_.isEmpty(treatments) && (
                    <>
                        <Box sx={{
                            borderBottom: 1,
                            borderColor: colors.extraLightBlue,
                            backgroundColor: 'white',
                            display: 'flex',
                            justifyContent: 'center',
                            overflowX: 'auto'
                        }}>
                            <Box sx={{
                                width: `${297 * transformScale}mm`,
                                maxWidth: '100%'
                            }}>
                                <UseStyled.DoctorTabs
                                    value={doctorTab}
                                    onChange={handleChangeTab}
                                    aria-label="doctor-tabs"
                                    variant="scrollable"
                                    scrollButtons
                                    allowScrollButtonsMobile>
                                    {_.map(treatments, (trm, index: number) => {
                                        return <Tab key={index} label={<span className='text-ellipsis w-100'>{`${trm?.firstname} ${trm?.lastname}`}</span>} {...a11yProps(index)} />
                                    })}
                                </UseStyled.DoctorTabs>
                            </Box>
                        </Box>
                        <ToastContainer enableMultiContainer containerId={'popup'} className={'Toast-popup'} />
                        <Box
                            sx={{
                                padding: '16px 0',
                                flex: 1,
                                overflow: 'auto',
                                display: 'flex',
                                justifyContent: 'center',
                                minHeight: `calc(${420 * transformScale}mm + 32px)`,
                            }}
                        >
                            <Box sx={{ transform: `scale(${transformScale})`, height: '0px' }}>
                                <Box ref={pdfInvoiceRef}>
                                    <PdfInvoice
                                        type={type}
                                        docterId={doctorTab}
                                        noteNextVisit={noteNextVisit}
                                        treatment={treatment}
                                        hideFooterImages
                                        showCashierInFooter={checkAddons(PACKAGE_ADDONS.ADDON_TREATMENT_FEE_STATEMENT)}
                                        staffName={user?.fullname || ''}
                                        showRemark={branchInfo?.pdfInvoiceShowRemark !== '0'}
                                        showNextVisit={branchInfo?.pdfInvoiceShowNextVisit !== '0'}
                                        clear={clear}
                                        submit={submit}
                                        disabledBtn={disabledBtn}
                                        onSubmit={(e) => {
                                            if (e) { dispatch(setCurrentInvoice(signatureCurrent)) }
                                            // Modal is closing (submit or cancel) — wipe pad LCD.
                                            wacom.clearPad()
                                        }}
                                        childrenModal={
                                            (modalType === 'doctor' ?
                                                <Box className={`signatureWrap-box w-100`} key={'doctor'}>
                                                    <Box className={`${treatment?.invoice?.doctorSignature ? 'pe-none' : ''}`}>
                                                        <UseStyled.SignBoxFee className='mx-auto' >
                                                            {treatment?.invoice?.doctorSignature && (
                                                                <img src={`data:image/png;base64,${treatment?.invoice?.doctorSignature}`} className="w-100 h-100" alt="" />
                                                            ) || (
                                                                    <Box className={`clear-box ${type === 'historyTreatment' ? 'd-none opacity-0' : ''}`} sx={{ display: 'flex', alignItems: 'center' }}>
                                                                        <Button variant="outlined" onClick={() => clearCanvas(modalType)}>
                                                                            {t('MODAL_TREATMENT_CONSENT.BUTTON.CLEAR_CANVAS')}
                                                                        </Button>
                                                                        <WacomStatusChip
                                                                            supported={wacom.supported}
                                                                            ready={wacom.ready}
                                                                            connecting={wacom.connecting}
                                                                            onConnect={wacom.connect}
                                                                            deviceName={wacom.deviceName}
                                                                        />
                                                                    </Box>
                                                                )}
                                                            <Box className="canvas-box" >
                                                                <CanvasDraw
                                                                    immediateLoading
                                                                    key={canvasKey}
                                                                    hideGrid
                                                                    hideInterface
                                                                    brushRadius={2}
                                                                    brushColor={colors.black}
                                                                    ref={canvasDoctorRef}
                                                                    imgSrc={defaultDoctorSignature}
                                                                    disabled={defaultDoctorSignature !== undefined}
                                                                    onChange={() => renderCanvas('doctor')}
                                                                />
                                                            </Box>
                                                        </UseStyled.SignBoxFee>
                                                    </Box>
                                                    <Box className='text-center mt-2'>
                                                        <Typography sx={{ fontWeight: 500 }}><span className='d-md-none'>(</span>{`${treatment?.firstname} ${treatment?.lastname}`}<span className='d-md-none'>)</span></Typography>
                                                        <Typography className='d-none d-md-block' sx={{ fontSize: 14 }}>{t('MODAL_TREATMENT_CONSENT.SIGN.DOCTOR')}</Typography>
                                                        <Typography className='d-none d-md-block' sx={{ fontSize: 14 }}>Dentist{"'"}s Signature</Typography>
                                                    </Box>
                                                </Box> :
                                                <Box className={`signatureWrap-box w-100`} key={'patient'}>
                                                    <Box className={`${treatment?.invoice?.patientSignature ? 'pe-none' : ''}`}>
                                                        <Box>{treatment?.invoice?.patientSignature}</Box>
                                                        <UseStyled.SignBoxFee className='mx-auto'>
                                                            {treatment?.invoice?.patientSignature && (
                                                                <img src={`data:image/png;base64,${treatment?.invoice?.patientSignature}`} className="w-100 h-100" alt="" />
                                                            ) || (
                                                                    <Box className={`clear-box ${type === 'historyTreatment' ? 'd-none opacity-0' : ''}`} sx={{ display: 'flex', alignItems: 'center' }}>
                                                                        <Button variant="outlined" onClick={() => clearCanvas('patient')}>
                                                                            {t('MODAL_TREATMENT_CONSENT.BUTTON.CLEAR_CANVAS')}
                                                                        </Button>
                                                                        <WacomStatusChip
                                                                            supported={wacom.supported}
                                                                            ready={wacom.ready}
                                                                            connecting={wacom.connecting}
                                                                            onConnect={wacom.connect}
                                                                            deviceName={wacom.deviceName}
                                                                        />
                                                                    </Box>
                                                                )}
                                                            <Box className="canvas-box">
                                                                <CanvasDraw
                                                                    key={canvasKey}
                                                                    hideGrid
                                                                    hideInterface
                                                                    brushRadius={2}
                                                                    lazyRadius={0}
                                                                    brushColor={colors.black}
                                                                    ref={canvasPatientRef}
                                                                    imgSrc={defaultPatientSignature}
                                                                    disabled={defaultPatientSignature !== undefined}
                                                                    onChange={() => renderCanvas('patient')} />
                                                            </Box>
                                                        </UseStyled.SignBoxFee>
                                                    </Box>
                                                    <Box className='text-center mt-2'>
                                                        <Typography sx={{ fontWeight: 500 }}><span className='d-md-none'>(</span>{`${treatment?.patientInfo?.firstname} ${treatment?.patientInfo?.lastname}`}<span className='d-md-none'>)</span></Typography>
                                                        <Typography className='d-none d-md-block' sx={{ fontSize: 14 }}>{t('MODAL_TREATMENT_CONSENT.SIGN.PATIENT')}</Typography>
                                                        <Typography className='d-none d-md-block' sx={{ fontSize: 14 }}>Patient{"'"}s Signature</Typography>
                                                    </Box>
                                                </Box>
                                            )
                                        }
                                        openModal={(e) => {
                                            setModalType(e);
                                            handleChange();
                                        }}
                                    />
                                </Box>
                            </Box>
                        </Box>

                        {/* Footer Buttons */}
                        <Box
                            sx={{
                                borderTop: `1px solid ${colors.extraLightBlue}`,
                                backgroundColor: 'white',
                                px: 3,
                                pt: 0,
                                pb: 2,
                                display: 'flex',
                                justifyContent: 'center',
                            }}
                        >
                            <MainButton
                                title={hasSaved ? 'บันทึกแล้ว' : saving ? 'กำลังบันทึก...' : 'ยืนยันการเซ็น'}
                                type='primary'
                                variant='contained'
                                onClick={onSaveToken}
                                disabled={hasSaved || saving || !currentInvoice?.doctorSignature || !currentInvoice?.patientSignature}
                                style={{ width: '140px' }}
                            />
                        </Box>

                        {loading && <Loading show={loading} type='softLoading' className='m-auto' />}
                    </>
                ) || (
                    <Box className='d-flex align-items-center justify-content-center h-100'>
                        <Typography className='text-center'>{type === 'historyTreatment' ? t('REGISTER.NO_ITEM') : t('MODAL_TREATMENT_CONSENT.NO_TREATMENT')}</Typography>
                    </Box>
                )
            ) || (
                    <Loading show={loading} type='softLoading' className='m-auto' />
                )}
        </Box>
    )
}

function a11yProps(index: number) {
    return {
        id: `doctor-tab-${index}`,
        'aria-controls': `doctor-tabpanel-${index}`,
    };
}
